import React, { useContext } from 'react'

import { ConnextContext } from './ConnextProvider'
import { updateMaintenance } from '../../../../api/ApiMaintenance'
import * as AlertMSGConstants from '../../../../constants/AlertMSGConstants'

import FormMaintenance from './form/FormMaintenance'
import ModalConnextView from '../../presentational/connext/ModalConnextView'

import { checkResStatusService } from '../../../../utilities/ResServiceUtils'

const EditMaintenance = ({
    callbackSaveSuccess
}) => {
    const { modalState, alertMessageState, loadingState } = useContext(ConnextContext)

    const handleSubmit = async values => {
        loadingState.showLoading()
        const { apiId, eventId, apiName, maId } = modalState.initData
        const res = await updateMaintenance({ ...values, maId, apiName, eventId, apiId })
        let altMsg = checkResStatusService(res)
        loadingState.hideLoading()

        if (res && res.data && res.data.maId) {
            alertMessageState.showAlert({
                altMsg: AlertMSGConstants.SAVE_SUCCESS,
                callbackCancel: () => {
                    alertMessageState.hideAlert()
                    callbackSaveSuccess()
                }
            })
        } else {
            alertMessageState.showAlert({ altMsg: altMsg ? altMsg : AlertMSGConstants.SYSTEM_ERROR })
        }
    }

    const handleCancel = () => {
        modalState.setModal()
    }

    return (
        <ModalConnextView>
            <FormMaintenance
                title="แก้ไขรายการแจ้งเตือนปิดระบบ"
                initData={modalState.initData}
                callBackSubmit={handleSubmit}
                callBackCancel={handleCancel}
            />
        </ModalConnextView>
    )
}

export default EditMaintenance
